import moment from 'moment';
import CRUDgeneric from 'utils/CRUDgeneric';
import API from 'utils/api';
import { onError } from 'utils/handlers';
import { ConfiguracionFormattDate, ConfiguracionFormatterById } from '../ConfigModelFormatters';

// Defino a donde el cliente consumira los enpoints.
const _cliente = CRUDgeneric('/nominas/configurar-guardias-vacacionales-excepciones/');
// El nombre del modelo que aparecera al agregar y editar.
const _nameModel = 'Excepción en Guardia Vacacional';
// El nombre del modelo para mencionar al nombre del registro.
const _nameModelSingular = 'la Área para Excepción de Guardia Vacacional del Área';

// Formatea el registro antes insertarlo al form.
const _formatRecordForRead = (record) => {
  const dataFormatedById = {
    ...ConfiguracionFormatterById(record),
    areas: record?.areas?.id,
    puesto: (record.puesto || []).map((t) => t.id),
    empleado: (record.empleado || []).map((t) => t.id),
    fecha_registro: record?.fecha_registro
      ? moment(record.fecha_registro)
      : null,
    configurar_guardias_vacacionales_general: record?.configurar_guardias_vacacionales_general?.id,
  };
  return dataFormatedById;
};
// Formatea el registro antes de enviarlo al backend.
/** necesario en fechas, de lo contrario solo volver a mandar el record */
const _formatRecordForSend = (record) => {
  const _record = ConfiguracionFormattDate(record);
  if (record.fecha_registro?.format) {
    _record.fecha_registro = record.fecha_registro.format('YYYY-MM-DD');
  }
  return _record;
};

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelInfoConfigGuardVacaExcepcion = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};

/**
 * GET Guardias Vacacionales Excepciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getGuardiasVacacionalesExcepciones = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);

/**
 * POST importar Excel de excepciones de guardias vacacionales
 * @param {File} archivo
 * @param {number} generalId
 * @returns {Promise<object>}
 */
export const importarExcelGuardiasExcepciones = async (archivo, generalId) => {
  try {
    const formData = new FormData();
    formData.append('archivo', archivo);
    const cleanId = String(generalId).replace(/\/$/, '');
    const response = await API.post(
      `/nominas/guardias-vacacionales-excepciones-importar-excel/?configurar_guardias_vacacionales_general=${cleanId}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

export const normalizeDataAreas = (_areasFetchArray) => {
  const mainMap = new Map();
  _areasFetchArray.forEach((item) => {
    mainMap.set(item.id, { ...item, children: [] });
  });

  const result = [];

  _areasFetchArray.forEach((item) => {
    if (item.directorio_area_padre) {
      const parent = mainMap.get(item.directorio_area_padre);
      if (parent) {
        parent.children.push(mainMap.get(item.id));
      }
    } else {
      result.push(mainMap.get(item.id));
    }
  });

  const sortByClave = (nodes) => {
    nodes.sort((a, b) => a.clave.localeCompare(b.clave));
    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        sortByClave(node.children);
      }
    });
  };

  sortByClave(result);

  return result;
};

// Esta función adapta el árbol para que funcione con TreeSelect
export const formatTreeSelectData = (nodes) => nodes.map((node) => ({
  title: `${node.clave} - ${node.nombre.trim()}`,
  value: node.id,
  children: node.children ? formatTreeSelectData(node.children) : [],
}));
